/*
<!--begin Convert Experiences code-->
  <script type="text/javascript">
  // fill in the values for the variables that you want to use
  var _conv_page_type = "";
  var _conv_category_id = "";
  var _conv_category_name = "";
  var _conv_product_sku = "";
  var _conv_product_name = "";
  var _conv_product_price = "";
  var _conv_customer_id = "";
  var _conv_custom_v1 = "";
  var _conv_custom_v2 = "";
  var _conv_custom_v3 = "";
  var _conv_custom_v4 = "";

  </script>
  <script type="text/javascript" src="//cdn-4.convertexperiments.com/js/10046307-10046776.js"></script>
<!-- end Convert Experiences code -->
*/

// plugins/convertcom.ts

function generateScriptBlock(convValues) {
  return "\n      var _conv_page_type = \"".concat(convValues.pageType || '', "\";\n      var _conv_category_id = \"").concat(convValues.categoryId || '', "\";\n      var _conv_category_name = \"").concat(convValues.categoryName || '', "\";\n      var _conv_product_sku = \"").concat(convValues.productSku || '', "\";\n      var _conv_product_name = \"").concat(convValues.productName || '', "\";\n      var _conv_product_price = \"").concat(convValues.productPrice || '', "\";\n      var _conv_customer_id = \"").concat(convValues.customerId || '', "\";\n      var _conv_custom_v1 = \"\";\n      var _conv_custom_v2 = \"\";\n      var _conv_custom_v3 = \"\";\n      var _conv_custom_v4 = \"\";\n      // add class to stop hydration delay\n      // document.documentElement.classList.add('cv-1-0');\n  ");
}
var convertComServer = ctx => {
  var convValues = {
    pageType: '',
    // replace with actual value
    categoryId: '',
    // replace with actual value
    categoryName: '',
    // replace with actual value
    productSku: '',
    // replace with actual value
    productName: '',
    // replace with actual value
    productPrice: '',
    // replace with actual value
    customerId: '' // replace with actual value
  };
  return {
    setValues(values) {
      Object.assign(convValues, values);
      if (process.client) {
        Object.entries(values).forEach(_ref => {
          var [key, value] = _ref;
          switch (key) {
            case 'pageType':
              window._conv_page_type = value;
              break;
            case 'categoryId':
              window._conv_category_id = value;
              break;
            case 'categoryName':
              window._conv_category_name = value;
              break;
            case 'productSku':
              window._conv_product_sku = value;
              break;
            case 'productName':
              window._conv_product_name = value;
              break;
            case 'productPrice':
              window._conv_product_price = value;
              break;
            case 'customerId':
              window._conv_customer_id = value;
              break;
          }
        });
      }
    },
    render() {
      var scriptBlock = generateScriptBlock(convValues);
      ctx.app.head.__dangerouslyDisableSanitizersByTagID = ctx.app.head.__dangerouslyDisableSanitizersByTagID || {};
      ctx.app.head.__dangerouslyDisableSanitizersByTagID['convert-experiences'] = ['innerHTML'];
      ctx.app.head.__dangerouslyDisableSanitizersByTagID['add-class-script'] = ['innerHTML'];
      var titleIndex = ctx.app.head.meta.findIndex(m => m.hid === 'title');
      ctx.app.head.script.splice(titleIndex + 1, 0, {
        hid: 'convert-experiences',
        innerHTML: scriptBlock
      }
      // {
      //   hid: 'convert-experiences-src',
      //   src: '//cdn-4.convertexperiments.com/js/10046307-10046776.js',
      //   type: 'text/javascript',
      //   'data-keep': true,
      // },
      // this is example convert.com code
      // if they do this in their code it willl work
      // {
      //   hid: 'add-class-script',
      //   innerHTML: `
      //     document.documentElement.classList.add('cv-1-0');
      //     function convertexperiments() {
      //       console.log('convertexperiments triggered')
      //       const locationRow = document.querySelector('.location-row');
      //       if (locationRow) {
      //         console.log('found location row')
      //         const spanElement = document.createElement('span');
      //         spanElement.textContent = 'testing';
      //         locationRow.before(spanElement);
      //       }
      //     }
      //   `,
      //   type: 'text/javascript',
      // },
      );
    }
  };
};
var convertComPlugin = (ctx, inject) => {
  var $convertCom = convertComServer(ctx);
  ctx.$convertCom = $convertCom;
  inject('convertCom', ctx.$convertCom);
  if (process.server) {
    ctx.beforeNuxtRender(() => {
      $convertCom.render();
    });
  }
};
export default convertComPlugin;